import { render, staticRenderFns } from "./todo-list-input.vue?vue&type=template&id=ef9f0fba&scoped=true"
import script from "./todo-list-input.vue?vue&type=script&lang=js"
export * from "./todo-list-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9f0fba",
  null
  
)

export default component.exports